import React, { useRef, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';

export default function AnimatedObject({visible}) {
  const { nodes,materials } = useGLTF('./models/animations/dumptruck.glb');
  const shipRef = useRef();
  const oreRef = useRef();
  const clock = useRef(new THREE.Clock());

  

const speedPerHour = 120000; // units per hour
const speedPerSecond = speedPerHour / 3600; // units per second

const startTimeRef = useRef(performance.now());

    const path = new THREE.CatmullRomCurve3([
  new THREE.Vector3(198802.8281, 1164.4299, -7999012.0000),
  new THREE.Vector3(198787.4531, 1166.4299, -7999011.5000),
  new THREE.Vector3(198781.2344, 1164.4299, -7999041.0000),
  new THREE.Vector3(198777.5781, 1164.4299, -7999073.5000),
  new THREE.Vector3(198809.0469, 1161.4299, -7999120.5000),
  new THREE.Vector3(198828.7969, 1161.4299, -7999126.5000),
  new THREE.Vector3(198836.4844, 1161.4299, -7999115.0000),
  new THREE.Vector3(198858.0625, 1163.4299, -7999088.0000),
  new THREE.Vector3(198880.7344, 1162.4299, -7999095.0000),
  new THREE.Vector3(198921.3438, 1161.4299, -7999095.0000),
  new THREE.Vector3(199020.8438, 1162.4299, -7999041.5000),
  new THREE.Vector3(199089.2500, 1164.4299, -7998975.0000),
  new THREE.Vector3(199119.7344, 1164.4299, -7998940.5000),
  new THREE.Vector3(199146.2500, 1166.4299, -7998934.5000),
  new THREE.Vector3(199140.1562, 1166.4299, -7998983.0000),
  new THREE.Vector3(199141.0781, 1166.4299, -7999000.5000),
//   new THREE.Vector3(199106.3906, 1166.4299, -7999212.0000),
//   new THREE.Vector3(199060.0312, 1166.4299, -7999397.5000),
//   new THREE.Vector3(198960.7812, 1166.4299, -7999626.5000),
//   new THREE.Vector3(198787.7500, 1166.4299, -8000014.0000),
//   new THREE.Vector3(198754.9062, 1166.4299, -8000106.5000),
//   new THREE.Vector3(198708.4375, 1166.4299, -8000268.5000),
//   new THREE.Vector3(198694.2812, 1166.4299, -8000362.0000),
//   new THREE.Vector3(198682.7344, 1166.4299, -8000465.5000),
//   new THREE.Vector3(198677.4844, 1166.4299, -8000589.0000),
//   new THREE.Vector3(198672.6562, 1166.4299, -8001138.0000),
//   new THREE.Vector3(198677.4844, 1166.4299, -8000589.0000),
//   new THREE.Vector3(198682.7344, 1166.4299, -8000465.5000),
//   new THREE.Vector3(198694.2812, 1166.4299, -8000362.0000),
//   new THREE.Vector3(198708.4375, 1166.4299, -8000268.5000),
//   new THREE.Vector3(198754.9062, 1166.4299, -8000106.5000),
//   new THREE.Vector3(198787.7500, 1166.4299, -8000014.0000),
//   new THREE.Vector3(198960.7812, 1166.4299, -7999626.5000),
//   new THREE.Vector3(199060.0312, 1166.4299, -7999397.5000),
//   new THREE.Vector3(199106.3906, 1166.4299, -7999212.0000),
  new THREE.Vector3(199145.3438, 1166.4299, -7998999.5000),
  new THREE.Vector3(199150.5312, 1166.4299, -7998940.0000),
  new THREE.Vector3(199154.4844, 1167.4299, -7998886.0000),
  new THREE.Vector3(199145.3438, 1167.4299, -7998877.5000),
  new THREE.Vector3(199136.5000, 1167.4299, -7998887.0000),
  new THREE.Vector3(199122.7812, 1165.4299, -7998925.0000),
  new THREE.Vector3(199104.1875, 1164.4299, -7998956.5000),
  new THREE.Vector3(199020.6562, 1162.4299, -7999038.0000),
  new THREE.Vector3(198977.0781, 1161.9299, -7999066.5000),
  new THREE.Vector3(198884.4531, 1162.4299, -7999095.5000),
  new THREE.Vector3(198857.4688, 1163.4299, -7999083.0000),
  new THREE.Vector3(198846.5469, 1163.4299, -7999095.0000),
  new THREE.Vector3(198833.5781, 1161.4299, -7999121.5000),
  new THREE.Vector3(198819.3594, 1161.4299, -7999126.0000),
  new THREE.Vector3(198798.2656, 1161.4299, -7999110.0000),
  new THREE.Vector3(198781.5000, 1164.4299, -7999073.5000),
  new THREE.Vector3(198781.7656, 1164.4299, -7999038.0000),
  new THREE.Vector3(198784.5625, 1166.4299, -7999013.0000),
  new THREE.Vector3(198825.2812, 1162.4299, -7999015.0000),
    ], true);

    const totalPathLength = path.getLength();

//   useEffect(() => {  
//     //if (!scene1 || !scene) return;
//     scene.scale.set(10, 10, 10);
//     //scene1.scale.set(10, 10, 10);
//     shipRef.current.add(scene);
//     shipRef.current.add(scene1);

//     shipRef.current.position.set(198802.8281, 1171.4299, -7999012.0000);
//   }, [scene,scene1]);


useFrame(() => {
  const elapsedSeconds = (performance.now() - startTimeRef.current) / 1000;

  // Distance travelled in units
  const distanceTravelled = elapsedSeconds * speedPerSecond;

  // Convert distance to a t value (normalized 0–1) along the path
  const t = (distanceTravelled % totalPathLength) / totalPathLength;

  const position = path.getPointAt(t);
  const tangent = path.getTangentAt(t).normalize();

  if (shipRef.current) {
    shipRef.current.position.copy(position);
    shipRef.current.lookAt(position.clone().add(tangent));
  }

  if (oreRef.current) {
    oreRef.current.visible = t<0.45||t>0.985;
  }

});

  return (visible && <group scale={10} dispose={null} ref={shipRef}>
      <mesh
        ref={oreRef}
        castShadow
        receiveShadow
        geometry={nodes.ore.geometry}
        material={materials['Material.005']}

      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.truck_Material002_0001.geometry}
        material={materials['Material.003']}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.truck_Material002_0001_1.geometry}
        material={materials['Material.004']}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.truck_Material002_0001_2.geometry}
        material={materials['clear.001']}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.truck_Material002_0001_3.geometry}
        material={materials['metal.002']}
      />
    </group>)
}
